import styled from 'styled-components';
import { primaryColor, white, black, highlightColor, primaryHoverColor } from 'Public/Css/colors';

export default styled.div `

    min-width: 28px;
    height: 28px;
    line-height: 28px;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    
    &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 24px;
        height: 24px;
        border: solid 1px ${black};
        border-radius: 2px;
    }

    &.checked::after {
        background-color: ${primaryColor};
        border: solid 1px ${primaryColor};
    }
    
    &.checked::before {
        content: ''; 
        width: 12px;
        height: 12px;
        margin-left: 6px;
        z-index: 5;
        box-shadow: inset 1em 1em ${white};
        clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    }

    &:hover::after {    
        background-color: ${highlightColor};
        opacity: 0.8;
    }

    &.checked:hover::after {    
        background-color: ${primaryHoverColor};
        opacity: 0.8;
    }
    
    .label {
        margin-left: 10px;
    }
  
    &.readonly {
      z-index: 1;

        &:before {
            background-color: #00000040;
        }
    
        &:after {
            z-index: -1;
            background-color: #f5f5f5;
            cursor: not-allowed;
            border: solid 1px #000000A5;

        }
    }
  
  
    
`;
